import BaseListPresenter from "../../base/BaseListPresenter";
import { upsertUseCase } from "../../usecases/object";
import { getCurrentUserUseCase } from "../../usecases/user";
import {
  format,
  startOfDay,
  addHours,
  addMinutes,
  addDays,
  parseISO,
} from "date-fns";

class CustomerPresenter extends BaseListPresenter {
  init() {
    this.store = [];
    // this.limit = 2000000;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.filterDate = {};
    this.filterStore = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
      },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }

  // async findObjects() {
  //   try {
  //     const user = await getCurrentUserUseCase().execute();
  //     const storeQuery = {
  //       include: ["all"],
  //       where: { email: user.email },
  //     };
  //     this.store = await this.findObjectUseCase.execute("users", storeQuery);

  //     const store = this.store[0].storeAnalytic.sort((a, b) => {
  //       const nameA = a.name.toUpperCase(); // ignore upper and lowercase
  //       const nameB = b.name.toUpperCase(); // ignore upper and lowercase
  //       if (nameA < nameB) {
  //         return -1;
  //       }
  //       if (nameA > nameB) {
  //         return 1;
  //       }
  //       return 0; // names must be equal
  //     });
  //     this.view.setStore(store);
  //   } catch (error) {
  //     console.error("Error fetching user or store data:", error);
  //     return;
  //   }

  //   const skip = (this.current - 1) * this.limit;
  //   const storeCodes = this.store?.flatMap((storeItem) =>
  //     storeItem.storeAnalytic?.map((analytic) => analytic?.name)
  //   );

  //   const query = {
  //     // limit: this.limit,
  //     skip: skip,
  //     where: {
  //       ...this.filterDate,
  //       store_code:
  //         this.filterStore === "AllStore"
  //           ? { $in: storeCodes }
  //           : this.filterStore,
  //       // cust_phone: "09204145112",
  //     },
  //     include: ["all"],
  //     sort: this.sort,
  //     keys: [
  //       "cust_name",
  //       "store_code",
  //       "tran_date",
  //       "cust_phone",
  //       "total",
  //       "cust_mobile",
  //       "cust_email",
  //       "items",
  //       "tran_id",
  //     ],
  //   };

  //   // Execute the query and update the view
  //   try {
  //     this.showProgress();
  //     this.findObjectUseCase.abort(); // Abort any previous use case execution
  //     // const objects = await this.findObjectUseCase.execute(
  //     //   this.view.getCollectionName(),
  //     //   query
  //     // );
  //     if (Object.keys(this.filterDate).length === 0) {
  //       console.log("data");
  //     } else {
  //       // this.objects = this.objects.concat(objects);
  //       // this.view.setTotal(this.objects.length);
  //       // console.log("Get Customer: ", this.objects);
  //       // this.view.setObjects(this.objects);
  //       const { count } = await this.countObjectUseCase.execute(
  //         this.view.getCollectionName(),
  //         {
  //           where: query.where,
  //         }
  //       );
  //       this.count = count;
  //       console.log("this.count", this.count);
  //       this.view.setCount(this.count);

  //       // Batching logic
  //       let buffer = [];
  //       let flushInterval = null;

  //       const flushBuffer = () => {
  //         if (buffer.length > 0) {
  //           this.view.setState((prevState) => ({
  //             objects: [...prevState.objects, ...buffer],
  //           }));
  //           this.objects = this.objects.concat(buffer);
  //           buffer = [];
  //           this.view.setTotal(this.objects.length);
  //           this.view.setObjects(this.objects);
  //         }
  //       };

  //       const onData = (objects) => {
  //         buffer.push(...objects);
  //       };

  //       flushInterval = setInterval(flushBuffer, 2000);

  //       const objects = await this.findObjectUseCase.execute(
  //         this.view.getCollectionName(),
  //         query,
  //         {
  //           timeout: 100000,
  //           onData,
  //         }
  //       );

  //       // Final flush and cleanup
  //       clearInterval(flushInterval);
  //       flushBuffer();

  //       // ✅ Check if no data was returned
  //       if (!this.count) {
  //         const not = true;
  //         // alert("wrok");
  //         this.view.setObjects([]);
  //         this.view.setNotFound(not);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching objects:", error);
  //     this.view.showError(error);
  //   } finally {
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }

  // async findObjects() {
  //   try {
  //     const user = await getCurrentUserUseCase().execute();
  //     const storeQuery = {
  //       include: ["all"],
  //       where: { email: user.email },
  //     };
  //     this.store = await this.findObjectUseCase.execute("users", storeQuery);

  //     const store = this.store[0].storeAnalytic.sort((a, b) =>
  //       a.name.toUpperCase().localeCompare(b.name.toUpperCase())
  //     );
  //     this.view.setStore(store);
  //   } catch (error) {
  //     console.error("Error fetching user or store data:", error);
  //     return;
  //   }

  //   const skip = (this.current - 1) * this.limit;
  //   const storeCodes = this.store?.flatMap((storeItem) =>
  //     storeItem.storeAnalytic?.map((analytic) => analytic?.name)
  //   );

  //   const query = {
  //     skip: skip,
  //     where: {
  //       ...this.filterDate,
  //       store_code:
  //         this.filterStore === "AllStore"
  //           ? { $in: storeCodes }
  //           : this.filterStore,
  //     },
  //     include: ["all"],
  //     sort: this.sort,
  //     keys: [
  //       "cust_name",
  //       "store_code",
  //       "tran_date",
  //       "cust_phone",
  //       "total",
  //       "cust_mobile",
  //       "cust_email",
  //       // "items",
  //       "tran_id",
  //     ],
  //   };

  //   try {
  //     this.showProgress();
  //     this.findObjectUseCase.abort();

  //     if (Object.keys(this.filterDate).length === 0) {
  //       console.log("data");
  //       return;
  //     }

  //     const { count } = await this.countObjectUseCase.execute(
  //       this.view.getCollectionName(),
  //       {
  //         where: query.where,
  //       }
  //     );
  //     this.count = count;
  //     this.view.setCount(count);

  //     // Reset state
  //     this.objects = [];
  //     this.view.setObjects([]);
  //     this.view.setTotal(0);
  //     this.view.setNotFound(false);

  //     let timeoutId = null;

  //     if (this.count === 0) {
  //       timeoutId = setTimeout(() => {
  //         if (this.count === 0) {
  //           this.view.setNotFound(true);
  //           this.view.setObjects([]);
  //           this.view.setTotal(0);
  //         }
  //       }, 15000); // delay for 15 seconds
  //     }

  //     // Batching logic
  //     let buffer = [];

  //     const flushBuffer = () => {
  //       if (buffer.length > 0) {
  //         this.view.setState((prevState) => ({
  //           objects: [...prevState.objects, ...buffer],
  //         }));
  //         this.objects = this.objects.concat(buffer);
  //         buffer = [];
  //         this.view.setTotal(this.objects.length);
  //         this.view.setObjects(this.objects);
  //       }
  //     };

  //     const onData = (objects) => {
  //       if (objects.length > 0 && timeoutId) {
  //         clearTimeout(timeoutId);
  //         timeoutId = null;
  //         this.view.setNotFound(false); // cancel "not found" UI
  //       }
  //       buffer.push(...objects);
  //     };

  //     const flushInterval = setInterval(flushBuffer, 2000);

  //     await this.findObjectUseCase.execute(
  //       this.view.getCollectionName(),
  //       query,
  //       {
  //         timeout: 200000,
  //         onData,
  //       }
  //     );

  //     clearInterval(flushInterval);
  //     flushBuffer();
  //   } catch (error) {
  //     console.error("Error fetching objects:", error);
  //     this.view.showError(error);
  //   } finally {
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }

  // async findObjects() {
  //   try {
  //     const user = await getCurrentUserUseCase().execute();

  //     const storeQuery = {
  //       include: ["all"],
  //       where: { email: user.email },
  //     };

  //     const userData = await this.findObjectUseCase.execute(
  //       "users",
  //       storeQuery
  //     );
  //     const storeAnalytics = userData[0]?.storeAnalytic || [];

  //     const sortedStores = storeAnalytics.sort((a, b) =>
  //       a.name.toUpperCase().localeCompare(b.name.toUpperCase())
  //     );

  //     this.store = userData;
  //     this.view.setStore(sortedStores);
  //   } catch (error) {
  //     console.error("Error fetching user/store data:", error);
  //     return;
  //   }

  //   if (Object.keys(this.filterDate).length === 0) {
  //     console.warn("No date filter applied. Skipping fetch.");
  //     return;
  //   }

  //   const skip = (this.current - 1) * this.limit;
  //   const storeCodes = this.store?.flatMap((storeItem) =>
  //     storeItem.storeAnalytic?.map((analytic) => analytic?.name)
  //   );

  //   const query = {
  //     skip,
  //     include: ["all"],
  //     sort: this.sort,
  //     where: {
  //       ...this.filterDate,
  //       store_code:
  //         this.filterStore === "AllStore"
  //           ? { $in: storeCodes }
  //           : this.filterStore,
  //       cust_name: { $ne: "-" },
  //       // cust_mobile: { $ne: "-" },
  //       cust_phone: { $ne: "-" },
  //     },
  //     keys: [
  //       "cust_name",
  //       "store_code",
  //       "tran_date",
  //       "cust_phone",
  //       "total",
  //       "cust_mobile",
  //       "cust_email",
  //       "tran_id",
  //       // "items",
  //     ],
  //   };

  //   try {
  //     this.showProgress();
  //     this.findObjectUseCase.abort();

  //     const { count } = await this.countObjectUseCase.execute(
  //       this.view.getCollectionName(),
  //       { where: query.where }
  //     );

  //     this.count = count;
  //     this.view.setCount(count);

  //     this.objects = [];
  //     this.view.setObjects([]);
  //     this.view.setTotal(0);
  //     this.view.setNotFound(false);

  //     if (count === 0) {
  //       setTimeout(() => {
  //         if (this.count === 0) {
  //           this.view.setNotFound(true);
  //           this.view.setObjects([]);
  //           this.view.setTotal(0);
  //         }
  //       }, 15000); // wait 15s before confirming "no data"
  //       return;
  //     }

  //     let buffer = [];
  //     const flushBuffer = () => {
  //       if (buffer.length > 0) {
  //         const newObjects = [...this.objects, ...buffer];
  //         this.objects = newObjects;
  //         this.view.setObjects(newObjects);
  //         this.view.setTotal(newObjects.length);
  //         buffer = [];
  //       }
  //     };

  //     const onData = (objects) => {
  //       if (objects.length > 0) {
  //         this.view.setNotFound(false);
  //         buffer.push(...objects);
  //       }
  //     };

  //     const flushInterval = setInterval(flushBuffer, 2000);

  //     await this.findObjectUseCase.execute(
  //       this.view.getCollectionName(),
  //       query,
  //       {
  //         timeout: 200000,
  //         onData,
  //       }
  //     );

  //     clearInterval(flushInterval);
  //     flushBuffer();

  //   } catch (error) {
  //     console.error("Error fetching objects:", error);
  //     this.view.showError(error);
  //   } finally {
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }

  async findObjects() {
    try {
      const user = await getCurrentUserUseCase().execute();

      const storeQuery = {
        include: ["all"],
        where: { email: user.email },
      };

      const userData = await this.findObjectUseCase.execute(
        "users",
        storeQuery
      );
      const storeAnalytics = userData[0]?.storeAnalytic || [];

      const sortedStores = storeAnalytics.sort((a, b) =>
        a.name.toUpperCase().localeCompare(b.name.toUpperCase())
      );

      this.store = userData;
      this.view.setStore(sortedStores);
    } catch (error) {
      console.error("Error fetching user/store data:", error);
      return;
    }

    if (Object.keys(this.filterDate).length === 0) {
      console.warn("No date filter applied. Skipping fetch.");
      return;
    }

    const skip = (this.current - 1) * this.limit;
    const storeCodes = this.store?.flatMap((storeItem) =>
      storeItem.storeAnalytic?.map((analytic) => analytic?.name)
    );

    const query = {
      skip,
      include: ["all"],
      sort: this.sort,
      where: {
        ...this.filterDate,
        store_code:
          this.filterStore === "AllStore"
            ? { $in: storeCodes }
            : this.filterStore,
        cust_name: { $ne: "-" },
        cust_phone: { $ne: "-" },
      },
      keys: [
        "cust_name",
        "store_code",
        "tran_date",
        "cust_phone",
        "total",
        "cust_mobile",
        "cust_email",
        "tran_id",
      ],
    };

    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const { count } = await this.countObjectUseCase.execute(
        this.view.getCollectionName(),
        { where: query.where }
      );

      this.count = count;
      this.view.setCount(count);

      this.objects = [];
      this.view.setObjects([]);
      this.view.setTotal(0);
      this.view.setNotFound(false);

      if (count === 0) {
        setTimeout(() => {
          if (this.count === 0) {
            this.view.setNotFound(true);
            this.view.setObjects([]);
            this.view.setTotal(0);
          }
        }, 15000);
        return;
      }

      let buffer = [];
      const flushBuffer = () => {
        if (buffer.length > 0) {
          const newObjects = [...this.objects, ...buffer];
          this.objects = newObjects;
          this.view.setObjects(newObjects);
          this.view.setTotal(newObjects.length);
          buffer = [];
        }
      };

      const onData = (objects) => {
        if (objects.length > 0) {
          this.view.setNotFound(false);
          buffer.push(...objects);
        }
      };

      const flushInterval = setInterval(flushBuffer, 2000);

      await this.findObjectUseCase.execute(
        this.view.getCollectionName(),
        query,
        {
          timeout: 200000,
          onData,
        }
      );

      clearInterval(flushInterval);
      flushBuffer();

      // Step 1: Deduplicate by raw cust_name
      const seenNames = new Set();
      const transactions = [];

      for (const txn of this.objects) {
        const rawName = txn.cust_name;
        if (rawName && !seenNames.has(rawName)) {
          seenNames.add(rawName);
          transactions.push(txn);
        }
      }

      const nameMap = new Map();
      for (const t of transactions) {
        const raw = t.cust_name;
        if (!nameMap.has(raw)) nameMap.set(raw, t);
      }

      const baseCustomers = Array.from(nameMap.values());
      const rawNames = Array.from(nameMap.keys());

      const chunkArray = (arr, size) => {
        const chunks = [];
        for (let i = 0; i < arr.length; i += size) {
          chunks.push(arr.slice(i, i + size));
        }
        return chunks;
      };

      const nameChunks = chunkArray(rawNames, 100);
      this.view.setAllChunks(nameChunks?.length);
      console.log(
        `⚡ Fetching transactions for ${rawNames.length} customers in ${nameChunks.length} chunks...`
      );

      const normalize = (name) => name?.trim().toUpperCase();

      async function runInParallelBatches(chunks, concurrency, handler) {
        const results = [];
        let index = 0;

        async function next() {
          if (index >= chunks.length) return;

          const currentIndex = index++;
          const chunk = chunks[currentIndex];

          try {
            const result = await handler(chunk, currentIndex);
            if (Array.isArray(result)) results.push(...result);
          } catch (e) {
            console.warn(`❌ Chunk ${currentIndex + 1} failed:`, e);
          }

          return next();
        }

        const workers = [];
        for (let i = 0; i < concurrency; i++) {
          workers.push(next());
        }

        await Promise.all(workers);
        return results;
      }

      const allTransactions = await runInParallelBatches(
        nameChunks,
        10,
        async (chunk, i) => {
          console.log(`⏳ Starting Chunk ${i + 1}/${nameChunks.length}`);
          this.view.setRunningChunks(i + 1);
          const start = Date.now();
          const res = await this.findObjectUseCase.execute("transactions", {
            where: { cust_name: { $in: chunk } },
            keys: [
              "store_code",
              "tran_date",
              "total",
              "tran_id",
              "cust_name",
              "cust_barangay",
              "cust_address",
              "cust_phone",
              "cust_mobile",
              "cust_email",
              "cust_birthday",
              "cust_card",
              "cust_notes",
              "landmark",
              "apcnumber",
              "deltime",
            ],
          });
          const ms = Date.now() - start;
          console.log(
            `✅ Chunk ${i + 1} → ${res?.length || 0} transactions (⏱ ${ms} ms)`
          );

          return res;
        }
      );

      const grouped = new Map();
      for (const txn of allTransactions) {
        const key = normalize(txn.cust_name);
        if (!grouped.has(key)) grouped.set(key, []);
        grouped.get(key).push(txn);
      }

      const enriched = baseCustomers.map((baseCustomer) => {
        const key = normalize(baseCustomer.cust_name);
        return {
          ...baseCustomer,
          transactions: grouped.get(key) || [],
        };
      });

      this.view.setEnrichedTransactions(enriched);
      console.log(
        `✅ Enriched ${enriched.length} customers with ${allTransactions.length} transactions.`
      );
    } catch (error) {
      console.error("Error fetching objects:", error);
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }

  // async findObjects() {
  //   try {
  //     const user = await getCurrentUserUseCase().execute();

  //     const storeQuery = {
  //       include: ["all"],
  //       where: { email: user.email },
  //     };

  //     const userData = await this.findObjectUseCase.execute(
  //       "users",
  //       storeQuery
  //     );
  //     const storeAnalytics = userData[0]?.storeAnalytic || [];

  //     const sortedStores = storeAnalytics.sort((a, b) =>
  //       a.name.toUpperCase().localeCompare(b.name.toUpperCase())
  //     );

  //     this.store = userData;
  //     this.view.setStore(sortedStores);
  //   } catch (error) {
  //     console.error("Error fetching user/store data:", error);
  //     return;
  //   }

  //   if (Object.keys(this.filterDate).length === 0) {
  //     console.warn("No date filter applied. Skipping fetch.");
  //     return;
  //   }

  //   const skip = (this.current - 1) * this.limit;
  //   const storeCodes = this.store?.flatMap((storeItem) =>
  //     storeItem.storeAnalytic?.map((analytic) => analytic?.name)
  //   );

  //   const query = {
  //     skip,
  //     include: ["all"],
  //     sort: this.sort,
  //     where: {
  //       ...this.filterDate,
  //       store_code:
  //         this.filterStore === "AllStore"
  //           ? { $in: storeCodes }
  //           : this.filterStore,
  //       cust_name: { $ne: "-" },
  //       cust_phone: { $ne: "-" },
  //     },
  //     keys: [
  //       "cust_name",
  //       "store_code",
  //       "tran_date",
  //       "cust_phone",
  //       "total",
  //       "cust_mobile",
  //       "cust_email",
  //       "tran_id",
  //     ],
  //   };

  //   try {
  //     this.showProgress();
  //     this.findObjectUseCase.abort();

  //     const { count } = await this.countObjectUseCase.execute(
  //       this.view.getCollectionName(),
  //       { where: query.where }
  //     );

  //     this.count = count;
  //     this.view.setCount(count);

  //     this.objects = [];
  //     this.view.setObjects([]);
  //     this.view.setTotal(0);
  //     this.view.setNotFound(false);

  //     if (count === 0) {
  //       setTimeout(() => {
  //         if (this.count === 0) {
  //           this.view.setNotFound(true);
  //           this.view.setObjects([]);
  //           this.view.setTotal(0);
  //         }
  //       }, 15000);
  //       return;
  //     }

  //     let buffer = [];
  //     const flushBuffer = () => {
  //       if (buffer.length > 0) {
  //         const newObjects = [...this.objects, ...buffer];
  //         this.objects = newObjects;
  //         this.view.setObjects(newObjects);
  //         this.view.setTotal(newObjects.length);
  //         buffer = [];
  //       }
  //     };

  //     const onData = (objects) => {
  //       if (objects.length > 0) {
  //         this.view.setNotFound(false);
  //         buffer.push(...objects);
  //       }
  //     };

  //     const flushInterval = setInterval(flushBuffer, 2000);

  //     await this.findObjectUseCase.execute(
  //       this.view.getCollectionName(),
  //       query,
  //       {
  //         timeout: 200000,
  //         onData,
  //       }
  //     );

  //     clearInterval(flushInterval);
  //     flushBuffer(); // Final flush

  //     // Step 1: Deduplicate by raw cust_name (keep trailing spaces)
  //     const seenNames = new Set();
  //     const transactions = [];

  //     for (const txn of this.objects) {
  //       const rawName = txn.cust_name;
  //       if (rawName && !seenNames.has(rawName)) {
  //         seenNames.add(rawName);
  //         transactions.push(txn);
  //       }
  //     }

  //     const nameMap = new Map(); // rawName => base txn
  //     for (const t of transactions) {
  //       const raw = t.cust_name;
  //       if (!nameMap.has(raw)) nameMap.set(raw, t);
  //     }

  //     const baseCustomers = Array.from(nameMap.values());
  //     const rawNames = Array.from(nameMap.keys()); // exact match list

  //     // Helper: chunk into batches of 100
  //     const chunkArray = (arr, size) => {
  //       const chunks = [];
  //       for (let i = 0; i < arr.length; i += size) {
  //         chunks.push(arr.slice(i, i + size));
  //       }
  //       return chunks;
  //     };

  //     const nameChunks = chunkArray(rawNames, 100);
  //     const allTransactions = [];

  //     let totalFetched = 0;
  //     let chunkIndex = 1;

  //     console.log("nameChunks", nameChunks);

  //     for (const chunk of nameChunks) {
  //       try {
  //         const res = await this.findObjectUseCase.execute("transactions", {
  //           where: { cust_name: { $in: chunk } },
  //           keys: [
  //             "store_code",
  //             "tran_date",
  //             "total",
  //             "tran_id",
  //             "cust_name",
  //             "cust_barangay",
  //             "cust_address",
  //             "cust_phone",
  //             "cust_mobile",
  //             "cust_email",
  //             "cust_birthday",
  //             "cust_card",
  //             "cust_notes",
  //             "landmark",
  //             "apcnumber",
  //             "deltime",
  //           ],
  //         });

  //         // allTransactions.push(...(res || []));
  //         const count = res?.length || 0;
  //         totalFetched += count;
  //         allTransactions.push(...(res || []));

  //         console.log(`✅ Chunk ${chunkIndex} → ${count} transactions`);
  //       } catch (err) {
  //         console.warn("Error in batch:", err);
  //       }
  //       chunkIndex++;
  //     }

  //     console.log(`🔢 Total fetched transactions: ${totalFetched}`);

  //     // Normalize helper
  //     const normalize = (name) => name?.trim().toUpperCase();

  //     // Group by normalized cust_name
  //     const grouped = new Map();
  //     for (const txn of allTransactions) {
  //       const key = normalize(txn.cust_name);
  //       if (!grouped.has(key)) grouped.set(key, []);
  //       grouped.get(key).push(txn);
  //     }

  //     // Final enrichment using normalized key
  //     const enriched = baseCustomers.map((baseCustomer) => {
  //       const key = normalize(baseCustomer.cust_name);
  //       return {
  //         ...baseCustomer,
  //         transactions: grouped.get(key) || [],
  //       };
  //     });

  //     this.view.setEnrichedTransactions(enriched);
  //     console.log("✅ Enriched transactions:", enriched);
  //   } catch (error) {
  //     console.error("Error fetching objects:", error);
  //     this.view.showError(error);
  //   } finally {
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }

  async asyncPool(poolLimit, array, iteratorFn) {
    const ret = [];
    const executing = [];

    for (const item of array) {
      const p = Promise.resolve().then(() => iteratorFn(item));
      ret.push(p);

      if (poolLimit <= array.length) {
        const e = p.then(() => executing.splice(executing.indexOf(e), 1));
        executing.push(e);
        if (executing.length >= poolLimit) {
          await Promise.race(executing);
        }
      }
    }

    return Promise.all(ret);
  }

  onChangeDate(where) {
    const { tran_date } = where;

    if (tran_date && tran_date.$gte && tran_date.$lte) {
      const startDate = addHours(startOfDay(parseISO(tran_date.$gte)), 5);
      const endDate = addMinutes(
        addHours(addDays(startOfDay(parseISO(tran_date.$lte)), 0), 4),
        59
      );

      const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
      const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

      this.filterDate = {
        tran_date: {
          $gte: formattedStartDate,
          $lte: formattedEndDate,
        },
      };
    }
    this.getObjects();
  }

  onChangeStore(where) {
    this.filterStore = where;
    this.getObjects();
  }

  calculateSums(objects) {
    const sumReducer = (acc, object, key) => acc + Number(object[key] || 0);

    const sum_total = objects?.reduce(
      (acc, obj) => sumReducer(acc, obj, "total"),
      0
    );

    const sum_discount = objects?.reduce(
      (acc, obj) => sumReducer(acc, obj, "discount_amount"),
      0
    );

    const sum_taxes = objects?.reduce(
      (acc, obj) => sumReducer(acc, obj, "total_tax"),
      0
    );

    return {
      sum_total,
      sum_discount,
      sum_taxes,
      grossSum: sum_total + sum_discount,
      grossSales: sum_total + sum_discount - sum_taxes,
    };
  }

  calculateTotalItemSoldSalesInfo() {
    const itemSold = this.objects;

    let totalQuantity = 0;

    if (Array.isArray(itemSold)) {
      for (let transaction of itemSold) {
        if (transaction.items && Array.isArray(transaction.items)) {
          for (let item of transaction.items) {
            let qty = Number(item.quantity);
            if (!isNaN(qty)) {
              totalQuantity += qty;
            }
          }
        }
      }
    } else {
      console.error("itemSold is not an array");
    }

    return {
      value: totalQuantity,
    };
  }

  calculateTotalTransactionInfo() {
    const prevTransaction = 5;
    const totalTransaction = this.objects;
    return {
      value: totalTransaction?.length,
      percentage: this.calculatePercentage(
        totalTransaction?.length,
        prevTransaction
      ),
    };
  }

  calculateTotalGuestInfo() {
    const prevCust = 6;
    const custCount = this.countCustomers();
    return {
      value: custCount,
      percentage: this.calculatePercentage(custCount, prevCust),
    };
  }

  calculateDiscountCost() {
    const prevCust = 6;
    const discountSum = this.objects
      ?.map((cust) => Number(cust.discount_amount))
      .reduce((acc, prev) => acc + prev, 0);
    return {
      value: discountSum,
      percentage: this.calculatePercentage(discountSum, prevCust),
    };
  }

  calculatePercentage(current, previous) {
    if (previous > 0 && current !== undefined) {
      return parseFloat(((current - previous) / previous) * 100).toFixed(2);
    }
    return 0;
  }

  countCustomers() {
    return this.objects
      ?.filter((cus) => cus.cust_name !== "-")
      .map((cust) => cust.cust_name).length;
  }
}

export default CustomerPresenter;
